import { useEffect, useState } from "react";
import {ServiceUtils} from "../../../Shared/Utils/ServiceUtils";
import { alertService } from "../../../Shared/Utils/ToasterUtils";
import { useNavigate } from "react-router-dom";

export const useFiltersHook = () => {
      const navigate = useNavigate();
      const [medicaidFilters, setMedicaidFilters] = useState([]);
    useEffect(() => {
        fetchMedicaidFilters();
    }, [])

    const fetchMedicaidFilters = () => {
      ServiceUtils.getRequest("fetchDropdownData").then(
        (response) => {
          if (response.status === 200 && response?.data.status) {
            let res = JSON.parse(JSON.stringify(response.data?.data));
            setMedicaidFilters(res);
          } else if (response.status === 401) {
            navigate("/logout");
          } else {
            alertService.error(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    };

    return medicaidFilters;
}

export const useMeetingsHook = (meetingFilters,view) => {
  const [meetings, setMeetings] = useState([]);
  const [filtersData, setDefaultFilters] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    fetchMeetings();
  },[meetingFilters,view]);

  const convertDate = (date) => {
    return new Date(date);
  };

  const fetchMeetings = () => {
    let payload = {};
    if (view && view === "agenda") {
      payload = {
        ...meetingFilters,
        year: meetingFilters.year,
      };
    } else {
      payload = {
        drugClasses: meetingFilters.drugClasses,
        meetingType: meetingFilters.meetingType,
        states: meetingFilters.states,
        meetingStatus: meetingFilters.meetingStatus,
        agendaStatus: meetingFilters.agendaStatus,
        therapyClass: meetingFilters.therapyClass,
        view: view,
        isFilterApplied: meetingFilters.isFilterApplied,
      };
    }

    ServiceUtils.postRequest("medicaidConferencesInfo", payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let medMeetingsData = JSON.parse(
            JSON.stringify(response?.data?.data?.meetingDetails),
          );
          const filtersApplied = JSON.parse(
            JSON.stringify(response?.data?.data?.filterData),
          );
          if (medMeetingsData?.length) {
            medMeetingsData?.map((meet, index) => {
              medMeetingsData[index].start = convertDate(medMeetingsData[index].start);
              medMeetingsData[index].end = convertDate(
                medMeetingsData[index].end,
              );
            });
          }
          setMeetings(medMeetingsData);
          setDefaultFilters(filtersApplied);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      },
    );
  };

  return {meetings, filtersData};
}

